import z from "zod";

export const postInitCalculationQuerySchema = z.discriminatedUnion("type", [
	z.object({ type: z.literal("parsc"), identifier: z.string() }),
	z.object({ type: z.literal("offer"), identifier: z.string().optional() }),
]);

export type PostInitCalculationQuerySchema = z.infer<typeof postInitCalculationQuerySchema>;
